// src/components/NotificationBell.js

import React from 'react';
import { db } from '../firebase';
import { doc, updateDoc, onSnapshot, query, where, collection, orderBy, writeBatch, deleteDoc } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
// GÜNCELLENDİ: 'Button' eklendi
import { Badge, Tooltip, IconButton, Menu, MenuItem, Typography, Box, Chip, Divider, Button, Stack } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';
import { tr } from 'date-fns/locale';

const NotificationBell = () => {
    const { currentUser } = useAuth();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [notifications, setNotifications] = React.useState([]);
    const navigate = useNavigate();

    React.useEffect(() => {
        if (!currentUser) return;
        const q = query(
            collection(db, "notifications"),
            where("userId", "==", currentUser.uid),
            orderBy("timestamp", "desc")
        );
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setNotifications(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });
        return () => unsubscribe();
    }, [currentUser]);

    const unreadCount = notifications.filter(notif => !notif.isRead).length;

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleMarkAsRead = async (id, link) => {
        if (id) {
            const docRef = doc(db, "notifications", id);
            await updateDoc(docRef, { isRead: true });
        }
        if (link) navigate(link);
        handleClose();
    };

    const handleMarkAllAsRead = async () => {
        const batch = writeBatch(db);
        notifications.forEach(notif => {
            if (!notif.isRead) {
                const docRef = doc(db, "notifications", notif.id);
                batch.update(docRef, { isRead: true });
            }
        });
        await batch.commit();
    };

    const handleDeleteNotification = async (e, notificationId) => {
        e.stopPropagation();
        if (!notificationId) return;
        try {
            const docRef = doc(db, "notifications", notificationId);
            await deleteDoc(docRef);
        } catch (error) {
            console.error("Bildirim silinirken hata:", error);
        }
    };

    return (
        <Box>
            <Tooltip title="Bildirimler">
                <IconButton color="inherit" onClick={handleClick}>
                    <Badge badgeContent={unreadCount} color="error">
                        <NotificationsIcon />
                    </Badge>
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        maxHeight: 400,
                        width: 360,
                        overflowX: 'hidden',
                        overflowY: 'auto'
                    }
                }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                {notifications.length > 0 ? [
                    <Box key="header" sx={{ p: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: 'grey.50', borderBottom: 1, borderColor: 'divider', position: 'sticky', top: 0, zIndex: 1 }}>
                        <Typography variant="subtitle2" sx={{ ml: 1 }}>Bildirimler ({unreadCount})</Typography>
                        <Stack direction="row" spacing={1}>
                            <Button size="small" onClick={handleMarkAllAsRead} disabled={unreadCount === 0}>Okundu</Button>
                            <Button size="small" color="error" onClick={async () => {
                                if (!window.confirm("Tüm bildirimleri silmek istediğinizden emin misiniz?")) return;
                                const batch = writeBatch(db);
                                // Maksimum 500 işlem (Firestore Batch Limiti)
                                notifications.slice(0, 500).forEach(notif => {
                                    const docRef = doc(db, "notifications", notif.id);
                                    batch.delete(docRef);
                                });
                                await batch.commit();
                            }}>Sil</Button>
                        </Stack>
                    </Box>,
                    notifications.map(notif => (
                        <MenuItem
                            key={notif.id}
                            onClick={() => handleMarkAsRead(notif.id, notif.link)}
                            sx={{
                                whiteSpace: 'normal',
                                borderBottom: '1px solid #eee',
                                backgroundColor: notif.isRead ? 'transparent' : 'action.hover',
                                py: 1.5
                            }}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
                                <Box sx={{ pr: 1, flex: 1 }}>
                                    <Typography variant="body2" fontWeight={notif.isRead ? "normal" : "bold"} sx={{ lineHeight: 1.2, mb: 0.5 }}>{notif.title}</Typography>
                                    <Typography variant="caption" display="block" color="text.primary" sx={{ lineHeight: 1.3 }}>{notif.message}</Typography>
                                    <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                                        {notif.timestamp ? formatDistanceToNow(notif.timestamp.toDate(), { addSuffix: true, locale: tr }) : ''}
                                    </Typography>
                                </Box>
                                <IconButton
                                    size="small"
                                    onClick={(e) => handleDeleteNotification(e, notif.id)}
                                    title="Bu bildirimi sil"
                                    sx={{ mt: -0.5, mr: -0.5 }}
                                >
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            </Box>
                        </MenuItem>
                    ))
                ] : (
                    <Box sx={{ p: 2, textAlign: 'center' }}>
                        <Typography color="text.secondary">Yeni bildirim yok.</Typography>
                    </Box>
                )}
            </Menu>
        </Box>
    );
};

export default NotificationBell;